import { Point } from 'geojson';
import { Equals, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';

export class GeographyPointDto implements Point {
  @ApiProperty({ type: 'string' })
  @Equals('Point')
  @Expose()
  type!: 'Point';

  @ApiProperty({ type: 'number', isArray: true })
  @IsNumber(undefined, { each: true })
  @Expose()
  coordinates!: number[];
}
